// src/components/common/AppLoader.jsx
import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function AppLoader({ message = "Loading..." }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        width: "100%",
        background: "rgba(255,255,255,0.8)", // subtle transparent overlay
        borderRadius: 2,
      }}
    >
      <CircularProgress size={50} thickness={4} />
      <Typography
        variant="body2"
        sx={{ mt: 2, color: "#444", fontWeight: 500 }}
      >
        {message}
      </Typography>
    </Box>
  );
}
